<template>
  <div class="w-100">
    <b-row no-gutters class="justify-content-center">
      <b-col cols="12" class="d-none d-md-flex justify-content-between">
        <div
          v-for="(lv1_info, lv1_idx) in sb_toc"
          :key="'dropdown_lv1' + lv1_idx"
          class="flex-grow-1 flex-column navbar-submenu justify-content-start px-3 uniform-width border-left"
          :class="{ 'border-right': lv1_idx === sb_toc.length - 1 }"
        >
          <div class="title-container pb-3">
            <span v-if="lang === 'KOR'" class="footer-title fw-700 text-white" :style="footerTitleStyle">
              {{ lv1_info.name }}
            </span>
            <span v-else class="footer-title text-white fw-700" :style="footerTitleStyle">
              {{ lv1_info.name_em ? lv1_info.name_em : lv1_info.name_ea }}
            </span>
          </div>

          <div v-for="(lv2_info, lv2_idx) in lv1_info.children" :key="'dropdown_lv2' + lv2_idx">
            <div
              v-if="
                lv2_info.appendix_type === null || report_types.includes(lv2_info.appendix_type)
              "
              class="link-container py-2"
              @click="update_lv2_info(lv1_info, lv2_info)"
            >
              <b-link class="py-2 no-underline">
                <span v-if="lang === 'KOR'" class="text-white footer-link f-90 fw-600" :style="footerTitleStyle2">
                  {{ lv2_info.name }}
                </span>
                <span v-else class="text-white footer-link f-90 fw-600" :style="footerTitleStyle2">
                  {{ lv2_info.name_em ? lv2_info.name_em : lv2_info.name_ea }}
                </span>
              </b-link>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
  import { updateParamsFromQueryString } from '@/components/util.js';

  export default {
    name: 'FooterNav',
    props: {
      lang: { type: String, default: 'KOR' },
    },
    computed: {
      ...mapState('report_list', ['view_mode']),
      ...mapGetters('assurance', ['latest_assurance']),
      ...mapGetters('story_board', ['selected_lv1', 'selected_lv2', 'sb_toc', 'selected_viewer_disclosures']),
      ...mapGetters('report_list', ['selected_report']),
      ...mapGetters(['is_viewer']),
      report_types() {
        const user_selected_report_type = Object.keys(this.selected_report.report_type).map(
          (item) => item.split('v')[0]
        );
        if (this.latest_assurance) {
          user_selected_report_type.push('ASSURANCE');
        }


        if (this.selected_report?.data_center) {
          user_selected_report_type.push('DATACENTER');
        }
        return user_selected_report_type;
      },
      // lv1_info 개수에 따른 폰트 크기 조절 (5개 이하: 기본, 6개 이상: 1개 증가마다 6% 감소)
      fontSizeScale() {
        const count = this.sb_toc.length;
        return count <= 5 ? 1 : 1 - 0.08 * (count - 5);
      },
      footerTitleStyle() {
        return {
          fontSize: (125 * this.fontSizeScale) + '%'
        };
      },
      footerTitleStyle2() {
        return {
          fontSize: (110 * this.fontSizeScale) + '%'
        };
      },
    },
    methods: {
      ...mapMutations('story_board', ['update_selected_lv1', 'update_selected_lv2']),
      ...mapActions('story_board', ['fetch_viewer_sb_disclosures']),
      updateQueryParam(key, value) {
        const url = new URL(window.location.href);

        if (value === null) {
          url.searchParams.delete(key);
        } else {
          url.searchParams.set(key, value);
        }

        window.history.pushState({}, '', url);
      },
      update_lv2_info(lv1_info, lv2_info) {
        window.scrollTo(0, 0);
        this.update_selected_lv1({ lv1_info: lv1_info, view_mode: this.is_viewer?'viewer':'editor'});
        this.update_selected_lv2({ lv2_info: lv2_info, view_mode: this.is_viewer?'viewer':'editor'});

        updateParamsFromQueryString('lv1', lv1_info.name, true);
        updateParamsFromQueryString('lv2', lv2_info.name, true);

        if (!this.selected_viewer_disclosures) {
          this.fetch_viewer_sb_disclosures({
            report_code: this.current_report_code,
            selected_lv_info: {
              lv1_info: lv1_info,
              lv2_info: lv2_info
            }
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .footer-title,
  .footer-link{
    white-space: pre-line;
  }
  .uniform-width {
    flex-basis: 0;
    flex-grow: 1;
  }

  .title-container {
    line-height: 1.2;
  }
  .link-container {
    line-height: 1.2;
    .no-underline {
      text-decoration: none !important;
    }

    .footer-link {
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }
  }

</style>
